import { writable } from 'svelte/store';

// SIGNED_OUT * | SIGNED_IN | PASSWORD_RESET | PASSWORD_RESET_REQUESTED | PASSWORD_SET_NEW
export const passwordResetState = writable('SIGNED_OUT');
